import State from '../interfaces/states/CommunicationState';

import * as Const from '../constants';

const initState: State = {
  communicationData: {
    data: [],
  },
  isLoading: false,
  isError: false,
};

export default function communication (state: State = initState, action): State {
  switch (action.type) {

    case Const.FETCH_COMMUNICATION_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_COMMUNICATION_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_COMMUNICATION_SUCCESS:
      return {
        ...state,
        communicationData: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_COMMUNICATION_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    default:
      return state;
  }
}
